module.exports = __webpack_public_path__ + "static/media/brand-refresh-home.96205ece.svg";